import { connect } from 'react-redux'
import NotificationTray, {
  NotificationTrayStateProps,
  NotificationTrayDispatchProps,
  NotificationTrayOwnProps,
} from 'components/features/pfm/NotificationTray/NotificationTray'
import {
  toggleNotificationsExpandedActionCreator,
  notificationsExpandButtonShownActionCreator,
  notificationsShownActionCreator,
} from 'actions/notificationsActions'
import { notificationsAreExpandedSelector, notificationsSelector } from 'selectors/notificationsSelectors'
import { createSelector } from 'reselect'
import { MapStateToProps } from 'react-redux'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { isMobileOrTabletSelector } from 'selectors/viewportSelectors'

type NotificationTrayOwnPropsInner =
  & NotificationTrayOwnProps
  & RouteComponentProps<{}>

const mapStateToProps: MapStateToProps<NotificationTrayStateProps, NotificationTrayOwnPropsInner> = createSelector(
  notificationsAreExpandedSelector,
  notificationsSelector,
  isMobileOrTabletSelector,
  (isExpanded, notifications, isMobileOrTablet) => ({
    isExpanded,
    notifications,
    isMobileOrTablet,
  }),
)

const mapDispatchToProps: NotificationTrayDispatchProps = {
  toggleExpanded: toggleNotificationsExpandedActionCreator,
  notificationsShown: notificationsShownActionCreator,
  expandButtonShown: notificationsExpandButtonShownActionCreator,
}

const NotificationTrayContainerInner = connect<
  NotificationTrayStateProps,
  NotificationTrayDispatchProps,
  NotificationTrayOwnPropsInner
>(mapStateToProps, mapDispatchToProps)(NotificationTray)

const NotificationTrayContainer = withRouter(NotificationTrayContainerInner)
export default NotificationTrayContainer
